import { combineReducers } from 'redux';
import {
    REQUEST_PASSWORD_RESET_INIT_USERNAME,
    SUCCESS_PASSWORD_RESET_INIT_USERNAME,
    FAILURE_PASSWORD_RESET_INIT_USERNAME,
    REQUEST_PASSWORD_RESET_INIT_EMAIL,
    SUCCESS_PASSWORD_RESET_INIT_EMAIL,
    FAILURE_PASSWORD_RESET_INIT_EMAIL,
    REQUEST_PASSWORD_RESET_COMMIT,
    SUCCESS_PASSWORD_RESET_COMMIT,
    FAILURE_PASSWORD_RESET_COMMIT
} from './constants';

/*
 * State shape
 {
    fetching: false,
    successPasswordResetInit: false,
    successPasswordResetCommit: false,
    error: ''
 }
*/

const fetchingPasswordResetInitUsername = (state = false, action) => {
    switch (action.type) {
        case REQUEST_PASSWORD_RESET_INIT_USERNAME:
            return true;
        case SUCCESS_PASSWORD_RESET_INIT_USERNAME:
        case FAILURE_PASSWORD_RESET_INIT_USERNAME:
            return false;
        default:
            return state;
    }
};

const errorPasswordResetInitUsername = (state = '', action) => {
    switch (action.type) {
        case FAILURE_PASSWORD_RESET_INIT_USERNAME:
            return action.response.message;
        case REQUEST_PASSWORD_RESET_INIT_USERNAME:
        case SUCCESS_PASSWORD_RESET_INIT_USERNAME:
            return '';
        default:
            return state;
    }
};

const successPasswordResetInitUsername = (state = false, action) => {
    switch (action.type) {
        case SUCCESS_PASSWORD_RESET_INIT_USERNAME:
            return true;
        case REQUEST_PASSWORD_RESET_INIT_USERNAME:
        case FAILURE_PASSWORD_RESET_INIT_USERNAME:
            return false;
        default:
            return state;
    }
};

const fetchingPasswordResetInitEmail = (state = false, action) => {
    switch (action.type) {
        case REQUEST_PASSWORD_RESET_INIT_EMAIL:
            return true;
        case SUCCESS_PASSWORD_RESET_INIT_EMAIL:
        case FAILURE_PASSWORD_RESET_INIT_EMAIL:
            return false;
        default:
            return state;
    }
};

const errorPasswordResetInitEmail = (state = '', action) => {
    switch (action.type) {
        case FAILURE_PASSWORD_RESET_INIT_EMAIL:
            return action.response.message;
        case REQUEST_PASSWORD_RESET_INIT_EMAIL:
        case SUCCESS_PASSWORD_RESET_INIT_EMAIL:
            return '';
        default:
            return state;
    }
};

const successPasswordResetInitEmail = (state = false, action) => {
    switch (action.type) {
        case SUCCESS_PASSWORD_RESET_INIT_EMAIL:
            return true;
        case REQUEST_PASSWORD_RESET_INIT_EMAIL:
        case FAILURE_PASSWORD_RESET_INIT_EMAIL:
            return false;
        default:
            return state;
    }
};

const fetchingPasswordResetCommit = (state = false, action) => {
    switch (action.type) {
        case REQUEST_PASSWORD_RESET_COMMIT:
            return true;
        case SUCCESS_PASSWORD_RESET_COMMIT:
        case FAILURE_PASSWORD_RESET_COMMIT:
            return false;
        default:
            return state;
    }
};

const errorPasswordResetCommit = (state = '', action) => {
    switch (action.type) {
        case FAILURE_PASSWORD_RESET_COMMIT:
            return action.response.message;
        case REQUEST_PASSWORD_RESET_COMMIT:
        case SUCCESS_PASSWORD_RESET_COMMIT:
            return '';
        default:
            return state;
    }
};

const successPasswordResetCommit = (state = false, action) => {
    switch (action.type) {
        case SUCCESS_PASSWORD_RESET_COMMIT:
            return true;
        case REQUEST_PASSWORD_RESET_COMMIT:
        case FAILURE_PASSWORD_RESET_COMMIT:
            return false;
        default:
            return state;
    }
};

export default combineReducers({
    fetchingPasswordResetInitUsername,
    errorPasswordResetInitUsername,
    successPasswordResetInitUsername,
    fetchingPasswordResetInitEmail,
    errorPasswordResetInitEmail,
    successPasswordResetInitEmail,
    fetchingPasswordResetCommit,
    errorPasswordResetCommit,
    successPasswordResetCommit
});



// WEBPACK FOOTER //
// ./src/services/authentication/resetpassword/reducer.js